import { Button, Card, Image } from "semantic-ui-react";
import { getFullDate } from "../../../js/helpers/dateHelpers";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import React, { useState } from "react";
import { listenToDocFromFirestore } from "../../../app/firestore/firestoreService";
import useFirestoreDoc from "../../../app/hooks/useFirestoreDoc";
import {
  FIRESTORE_USERS_COLLECTION,
  QUERY_CODES,
} from "../../../app/firestore/firestoreConstants";
import { CLF_PROMOTION_TYPE } from "../adminConstants";
import { reviewService } from "../../../app/api/adminAPI";
import { PAYMENT_COMPANY_LOGO_FEATURE_SERVICE } from "../../payments/paymentConstants";

export default function AdminReviewFeaturedCompanyLogoRequest({
  logo,
  type = CLF_PROMOTION_TYPE.underReview,
}) {
  const [isApproving, setIsApproving] = useState(false);
  const [employerDetails, setEmployerDetails] = useState(null);

  useFirestoreDoc({
    shouldExecute: employerDetails === null,
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_USERS_COLLECTION,
        id: logo.employerId,
      }),
    data: (details) => setEmployerDetails(details),
    deps: [logo.employerId],
    queryCode: QUERY_CODES.getUserAccount,
  });

  async function handleAdminAction(logo) {
    try {
      setIsApproving(true);
      if (
        type === CLF_PROMOTION_TYPE.underReview &&
        !logo.isInitialised &&
        !logo.isApproved
      ) {
        await reviewService({
          service: PAYMENT_COMPANY_LOGO_FEATURE_SERVICE,
          id: logo.id,
          employerId: logo.employerId,
        });

        return;
      }
      setIsApproving(false);
    } catch (e) {
      console.log(e);
    }
  }

  if (!employerDetails) {
    return <div />;
  }

  const isCompanyId = logo?.companyId === employerDetails?.companyId;
  console.log(isCompanyId);

  return (
    <Card style={{ width: "23%" }} key={logo.id}>
      <div className="body-blue-text center aligned">
        {logo.isFree && <span className="accent-colour">(Free)</span>}
      </div>
      <Card.Content textAlign="center">
        <Image
          size="small"
          src={logo.featuredCompanyLogoURL}
          style={{ border: "1px solid grey" }}
        />
      </Card.Content>
      <Card.Content>
        <div className="semi-bold">
          Submitted: {getFullDate(logo.datePurchased)}
        </div>
        <CopyToClipboard text={logo.paymentIntentId}>
          <div
            className="clickable fitted"
            style={{ padding: "0 8px", margin: "8px 0 0" }}
          >
            Copy payment intent Id
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={logo.employerId}>
          <div
            className="clickable fitted"
            style={{ padding: "0 8px", margin: "8px 0 5px" }}
          >
            Copy employer Id
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={logo.id}>
          <div
            className="clickable fitted"
            style={{ padding: "0 8px", margin: "8px 0 5px" }}
          >
            Copy logo Id
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={employerDetails.companyId}>
          <div
            className="clickable fitted"
            style={{ padding: "0 8px", margin: "0 0 15px 0" }}
          >
            <div>Copy Emp Company Id</div>
            <div> Company Id check {isCompanyId ? "PASS" : "FAIL"}</div>
          </div>
        </CopyToClipboard>
      </Card.Content>
      <Card.Content extra>
        <Button
          className="overwrite-button orange-inverse-button"
          style={{ marginLeft: 10 }}
          content={"Approve"}
          disabled={isApproving || !employerDetails || !isCompanyId}
          loading={isApproving}
          floated={"right"}
          onClick={() => handleAdminAction(logo)}
        />
      </Card.Content>
    </Card>
  );
}
